import React, { useMemo } from 'react'
import Lottie from 'react-lottie'
import PropTypes from 'prop-types'

function LottieAnimation({ options = {}, style, height = 'auto', width = 'auto', animationData }) {
  const defaultOptions = useMemo(
    () => ({
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
      ...options,
    }),
    [options, animationData],
  )

  return <Lottie height={height} options={defaultOptions} style={style} width={width} />
}

LottieAnimation.propTypes = {
  options: PropTypes.object,
  style: PropTypes.object,
  height: PropTypes.number,
  width: PropTypes.number,
  animationData: PropTypes.object.isRequired,
}

export default LottieAnimation
